import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/wrapNativeSuper";
var _excluded = ["query", "label"],
  _excluded2 = ["query", "label"],
  _excluded3 = ["query", "label"],
  _excluded4 = ["query", "label"],
  _excluded5 = ["query", "label"],
  _excluded6 = ["query", "label"],
  _excluded7 = ["query", "label"],
  _excluded8 = ["query", "label"],
  _excluded9 = ["query", "label"],
  _excluded10 = ["query", "label"];
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
/* eslint-disable max-classes-per-file */import identity from 'lodash/identity';
import set from 'lodash/set';
import { createAction } from 'redux-act';
import { GET, HEAD, POST, PUT, PATCH, DELETE } from 'gandi.redux-fetcher';
import { DEFAULT_LABEL, FETCH_LIST_START, FETCH_LIST_SUCCESS, FETCH_LIST_FAILURE, FETCH_ONE_START, FETCH_ONE_SUCCESS, FETCH_ONE_FAILURE, CREATE_ONE_START, CREATE_ONE_SUCCESS, CREATE_ONE_FAILURE, UPDATE_ONE_START, UPDATE_ONE_SUCCESS, UPDATE_ONE_FAILURE, PATCH_ONE_START, PATCH_ONE_SUCCESS, PATCH_ONE_FAILURE, DELETE_ONE_START, DELETE_ONE_SUCCESS, DELETE_ONE_FAILURE, HEAD_START, HEAD_SUCCESS, HEAD_FAILURE, POST_START, POST_SUCCESS, POST_FAILURE, PUT_START, PUT_SUCCESS, PUT_FAILURE, PATCH_START, PATCH_SUCCESS, PATCH_FAILURE, INVALIDATE } from './constants';
var ExtendableError = /*#__PURE__*/function (_Error) {
  _inherits(ExtendableError, _Error);
  var _super = _createSuper(ExtendableError);
  function ExtendableError(message) {
    var _this;
    _classCallCheck(this, ExtendableError);
    _this = _super.call(this, message);
    _this.name = _this.constructor.name;
    _this.message = message;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }
    return _this;
  }
  return _createClass(ExtendableError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
// eslint-disable-next-line no-redeclare
export function isFetchError(error) {
  return 'response' in error;
}
export var FetchError = /*#__PURE__*/function (_ExtendableError) {
  _inherits(FetchError, _ExtendableError);
  var _super2 = _createSuper(FetchError);
  function FetchError(message) {
    var _this2;
    _classCallCheck(this, FetchError);
    _this2 = _super2.call(this, message);
    // List of api errors (`response.data.errors` if any)
    _this2.errors = {};
    _this2.response = null;
    return _this2;
  }

  // eslint-disable-next-line no-use-before-define
  _createClass(FetchError, null, [{
    key: "fromError",
    value: function fromError(error) {
      var err = new FetchError(error.message);
      err.originalError = error;
      return err;
    }

    // instanceof does not behave as expected here

    // (optional) Fetch response object
  }]);
  return FetchError;
}(ExtendableError);

/**
 * extract error messages from REST API response (not 5xx errors).
 * Convention: If API errors, it will return, under the key "errors" an array of errors.
 */
FetchError.isFetchError = isFetchError;
export var parseApiErrors = function parseApiErrors(response) {
  var _response$data, _response$data2;
  var errors = {};
  if (Array.isArray((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.errors)) {
    // map errors to the form expected format
    errors = response.data.errors.reduce(function (acc, error) {
      if (!error.name) {
        // eslint-disable-next-line no-console
        console.error('Unable to parse error as it does not fit the common format');
        return acc;
      }
      set(acc, error.name, error.description);
      if (error.location !== 'body' && !('_error' in acc)) {
        acc._error = error.description;
      }
      if (error.name.indexOf('.') > -1) {
        Object.defineProperty(acc, error.name.replace('.', ''), {
          get: function get() {
            if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
              // eslint-disable-next-line no-console
              console.warn("This property ".concat(error.name.replace('.', ''), " is deprecated."), "Please use the property ".concat(error.name.split('.').shift(), " instead."));
            }
            return error.description;
          },
          // set this property has configurable to not trigger a
          // 'cannot redefine property' error in case of several errors has the same name
          configurable: true
        });
      }
      return acc;
    }, {});
  } else if (typeof ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.message) === 'string') {
    errors = {
      _error: response.data.message
    };
  }
  return errors;
};

/**
 * In case the promise was rejected with the response,
 * there will be an attempt to parse api response
 *
 * @param {string} message technical message for logging purpose
 */
export var catchApiError = function catchApiError(message) {
  return function (response) {
    // expect the response, if this is not a response object, then forward
    // the error
    if (!(response && 'status' in response)) throw response;
    var error = new FetchError(message);
    error.response = response;
    if (typeof response.status === 'number' && !/^5/.test("".concat(response.status))) {
      // attempt to show API message
      error.errors = parseApiErrors(response);
    } else {
      // wether there where no parseable error or the original error
      // should be hidden to user to prevent technical details to be
      // displayed (500...)
      error.errors = {};
    }
    throw error;
  };
};
export var handleFailure = function handleFailure(onFailure) {
  return function (err) {
    var error;
    // if err is not a FetchError, then it is a code error,
    // we should transform to have a consistent api.
    // XXX: sure? we should throw in case of userland code error?
    if (FetchError.isFetchError(err)) {
      error = err;
    } else {
      error = FetchError.fromError(err);
    }

    // the callback is actually a dispatch
    // XXX: this could have a better design since the only purpose of this function
    //  is to make sure that we dispatch a `FetchError` (that might not be a real FetchError)
    onFailure(error);
    return _Promise.reject(error);
  };
};

/**
 * Build definitive URL from url pattern and query.
 * let's keep it simple for now :)
 * @deprecated this does not support arrays, (params from gandi.fetcher does).
 */
var computeUrl = function computeUrl(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return [url, _Object$keys(query).filter(function (key) {
    return query[key] !== undefined;
  }).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(query[key].toString()));
  }).join('&')].filter(identity).join('?');
};
var networkHandlerTest = /^(not|on)(X|\d){3}$/;
/**
 * Add default handlers to `options` if there is no handler at all
 */
// XXX: this return is a mix of Handlers and fetcher options (timout ...)
//      for redux-fetcher
// Then main problem is it's not clear so we pass ActionOption that also have
//  other unrelated properties (label, query…)
// Due to dynamic handlers name (e.g. `not2XX`|`on500`…), the implementation
//  requires to use defensive code like `typeof handlers.on2XX === 'function'`
//  or FlowFixMe
export var ensureDefaultHandlers = function ensureDefaultHandlers() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _Object$keys(options).filter(function (key) {
    return networkHandlerTest.test(key);
  }).length === 0 ? _objectSpread(_objectSpread({}, options), defaultHandlers) : options;
};

/**
 * Create some meta for the action.
 * All resource action has a `resource` field in action payload, it helps
 * intercepting actions to track life cycle events in global resource reducer.
 *
 * @param {string} actionType generic type of action
 * @return {function}
 */
var metaReducerFactory = function metaReducerFactory(type, resource) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      label = _ref.label;
    return {
      type: type,
      resource: resource,
      label: label
    };
  };
};
/**
 * strip `query` from payload (todo?)
 * @param {mixed} query request associated query, used as a scope
 * @return {object}
 * TODO: (types) PayloadReducer is not well named and it should be actually an union
 * of Payloads (but cannot work since there is no disjoint union property)
 */
var payloadReducer = function payloadReducer() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return payload;
};

/**
 * Declare a set of action creators factories.
 *
 * Each of them accept a resource and return an action creator that perfoms
 * an HTTP call, dispatch actions (start, success, failure) and return a
 * ActionReturn.
 */

export var createFetchListAction = function createFetchListAction(resource) {
  var start = createAction("[".concat(resource, "] start fetching list of resources"), payloadReducer, metaReducerFactory(FETCH_LIST_START, resource));
  var success = createAction("[".concat(resource, "] successfuly fetched list of resources"), payloadReducer, metaReducerFactory(FETCH_LIST_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed to fetch list of resources"), payloadReducer, metaReducerFactory(FETCH_LIST_FAILURE, resource));
  var doFetchList = function doFetchList(url) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      query = _ref2.query,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? DEFAULT_LABEL : _ref2$label,
      extra = _objectWithoutProperties(_ref2, _excluded);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(GET(definitiveUrl, ensureDefaultHandlers(extra, {
        on200: function on200(response) {
          return response;
        },
        not200: function not200(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Unable to fetch collection ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread(_objectSpread({}, payload), {}, {
          response: response
        })));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread(_objectSpread({}, payload), {}, {
          error: error
        })));
      }));
    };
  };
  doFetchList.start = start;
  doFetchList.success = success;
  doFetchList.failure = failure;

  /**
   * Even though it can return a FetchError, in userland it will only type the successful promise.
   * A rejected promise will be typed as 'any' and such needs to be typed manually.
   * @example dispatch(fetchList()).then(...).catch((err: FetchError) => ...)
   */
  // $FlowIgnore[incompatible-exact]
  return doFetchList;
};
export var createFetchOneAction = function createFetchOneAction(resourceName) {
  var start = createAction("[".concat(resourceName, "] start fetching single resource"), payloadReducer, metaReducerFactory(FETCH_ONE_START, resourceName));
  var success = createAction("[".concat(resourceName, "] successfuly fetched single resource"), payloadReducer, metaReducerFactory(FETCH_ONE_SUCCESS, resourceName));
  var failure = createAction("[".concat(resourceName, "] failed to fetch single resource"), payloadReducer, metaReducerFactory(FETCH_ONE_FAILURE, resourceName));
  var doFetchOne = function doFetchOne(url) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      query = _ref3.query,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? DEFAULT_LABEL : _ref3$label,
      extra = _objectWithoutProperties(_ref3, _excluded2);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resourceName,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(GET(definitiveUrl, ensureDefaultHandlers(extra, {
        on200: function on200(response) {
          return response;
        },
        not200: function not200(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Unable to fetch resource ".concat(resourceName, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload
        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doFetchOne.start = start;
  doFetchOne.success = success;
  doFetchOne.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doFetchOne;
};
export var createCreateOneAction = function createCreateOneAction(resource) {
  var start = createAction("[".concat(resource, "] start creating single resource"), payloadReducer, metaReducerFactory(CREATE_ONE_START, resource));
  var success = createAction("[".concat(resource, "] successfuly created single resource"), payloadReducer, metaReducerFactory(CREATE_ONE_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed to create single resource"), payloadReducer, metaReducerFactory(CREATE_ONE_FAILURE, resource));
  var doCreateOne = function doCreateOne(url, doc) {
    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      query = _ref4.query,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? DEFAULT_LABEL : _ref4$label,
      extra = _objectWithoutProperties(_ref4, _excluded3);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(POST(definitiveUrl, doc, ensureDefaultHandlers(extra, {
        on201: function on201(response) {
          return response;
        },
        not201: function not201(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Unable to create resource ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doCreateOne.start = start;
  doCreateOne.success = success;
  doCreateOne.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doCreateOne;
};
export var createUpdateOneAction = function createUpdateOneAction(resource) {
  var start = createAction("[".concat(resource, "] start updating single resource"), payloadReducer, metaReducerFactory(UPDATE_ONE_START, resource));
  var success = createAction("[".concat(resource, "] successfuly updated single resource"), payloadReducer, metaReducerFactory(UPDATE_ONE_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed to update single resource"), payloadReducer, metaReducerFactory(UPDATE_ONE_FAILURE, resource));
  var doUpdateOne = function doUpdateOne(url, doc) {
    var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      query = _ref5.query,
      _ref5$label = _ref5.label,
      label = _ref5$label === void 0 ? DEFAULT_LABEL : _ref5$label,
      extra = _objectWithoutProperties(_ref5, _excluded4);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(PUT(definitiveUrl, doc, ensureDefaultHandlers(extra, {
        on202: function on202(response) {
          return response;
        },
        not202: function not202(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Unable to update resource ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doUpdateOne.start = start;
  doUpdateOne.success = success;
  doUpdateOne.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doUpdateOne;
};
export var createPostAction = function createPostAction(resource) {
  var start = createAction("[".concat(resource, "] start POST request"), payloadReducer, metaReducerFactory(POST_START, resource));
  var success = createAction("[".concat(resource, "] successfull POST request"), payloadReducer, metaReducerFactory(POST_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed POST request"), payloadReducer, metaReducerFactory(POST_FAILURE, resource));
  var doPost = function doPost(url, body) {
    var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      query = _ref6.query,
      _ref6$label = _ref6.label,
      label = _ref6$label === void 0 ? DEFAULT_LABEL : _ref6$label,
      extra = _objectWithoutProperties(_ref6, _excluded5);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(POST(definitiveUrl, body, ensureDefaultHandlers(extra, {
        on201: function on201(response) {
          return response;
        },
        not201: function not201(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Failed POST request for ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doPost.start = start;
  doPost.success = success;
  doPost.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doPost;
};
export var createPutAction = function createPutAction(resource) {
  var start = createAction("[".concat(resource, "] start PUT request"), payloadReducer, metaReducerFactory(PUT_START, resource));
  var success = createAction("[".concat(resource, "] successfull PUT request"), payloadReducer, metaReducerFactory(PUT_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed PUT request"), payloadReducer, metaReducerFactory(PUT_FAILURE, resource));
  var doPut = function doPut(url, body) {
    var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      query = _ref7.query,
      _ref7$label = _ref7.label,
      label = _ref7$label === void 0 ? DEFAULT_LABEL : _ref7$label,
      extra = _objectWithoutProperties(_ref7, _excluded6);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(PUT(definitiveUrl, body, ensureDefaultHandlers(extra, {
        on202: function on202(response) {
          return response;
        },
        not202: function not202(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Failed PUT request for ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doPut.start = start;
  doPut.success = success;
  doPut.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doPut;
};
export var createPatchAction = function createPatchAction(resource) {
  var start = createAction("[".concat(resource, "] start PATCH request"), payloadReducer, metaReducerFactory(PATCH_START, resource));
  var success = createAction("[".concat(resource, "] successfull PATCH request"), payloadReducer, metaReducerFactory(PATCH_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed PATCH request"), payloadReducer, metaReducerFactory(PATCH_FAILURE, resource));
  var doPatch = function doPatch(url, body) {
    var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      query = _ref8.query,
      _ref8$label = _ref8.label,
      label = _ref8$label === void 0 ? DEFAULT_LABEL : _ref8$label,
      extra = _objectWithoutProperties(_ref8, _excluded7);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(PATCH(definitiveUrl, body, ensureDefaultHandlers(extra, {
        on202: function on202(response) {
          return response;
        },
        not202: function not202(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Failed PATCH request for ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doPatch.start = start;
  doPatch.success = success;
  doPatch.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doPatch;
};
export var createHeadAction = function createHeadAction(resource) {
  var start = createAction("[".concat(resource, "] start HEAD request"), payloadReducer, metaReducerFactory(HEAD_START, resource));
  var success = createAction("[".concat(resource, "] successfull HEAD request"), payloadReducer, metaReducerFactory(HEAD_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed HEAD request"), payloadReducer, metaReducerFactory(HEAD_FAILURE, resource));
  var doHead = function doHead(url) {
    var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      query = _ref9.query,
      _ref9$label = _ref9.label,
      label = _ref9$label === void 0 ? DEFAULT_LABEL : _ref9$label,
      extra = _objectWithoutProperties(_ref9, _excluded8);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(HEAD(definitiveUrl, ensureDefaultHandlers(extra, {
        on200: function on200(response) {
          return response;
        },
        not200: function not200(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Failed HEAD request for ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doHead.start = start;
  doHead.success = success;
  doHead.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doHead;
};
export var createPatchOneAction = function createPatchOneAction(resource) {
  var start = createAction("[".concat(resource, "] start patch single resource"), payloadReducer, metaReducerFactory(PATCH_ONE_START, resource));
  var success = createAction("[".concat(resource, "] successfuly updated single resource"), payloadReducer, metaReducerFactory(PATCH_ONE_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed to update single resource"), payloadReducer, metaReducerFactory(PATCH_ONE_FAILURE, resource));
  var doPatchOne = function doPatchOne(url, doc) {
    var _ref10 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      query = _ref10.query,
      _ref10$label = _ref10.label,
      label = _ref10$label === void 0 ? DEFAULT_LABEL : _ref10$label,
      extra = _objectWithoutProperties(_ref10, _excluded9);
    return function (dispatch) {
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      return dispatch(PATCH(definitiveUrl, doc, ensureDefaultHandlers(extra, {
        on202: function on202(response) {
          return response;
        },
        not202: function not202(response) {
          return _Promise.reject(response);
        }
      }))).catch(catchApiError("Unable to patch resource ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload

        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doPatchOne.start = start;
  doPatchOne.success = success;
  doPatchOne.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doPatchOne;
};
export var createDeleteOneAction = function createDeleteOneAction(resource) {
  var start = createAction("[".concat(resource, "] start deleting single resource"), payloadReducer, metaReducerFactory(DELETE_ONE_START, resource));
  var success = createAction("[".concat(resource, "] successfuly deleted single resource"), payloadReducer, metaReducerFactory(DELETE_ONE_SUCCESS, resource));
  var failure = createAction("[".concat(resource, "] failed to delete single resource"), payloadReducer, metaReducerFactory(DELETE_ONE_FAILURE, resource));
  var doDeleteOne = function doDeleteOne(url) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return function (dispatch) {
      var legacy = args.length === 1;
      var options = args[args.length - 1];
      var _ref11 = options || {},
        query = _ref11.query,
        _ref11$label = _ref11.label,
        label = _ref11$label === void 0 ? DEFAULT_LABEL : _ref11$label,
        extra = _objectWithoutProperties(_ref11, _excluded10);
      var payload = _objectSpread({
        resource: resource,
        query: query,
        label: label
      }, extra);
      dispatch(start(payload));
      var definitiveUrl = computeUrl(url, query);
      var doc = args[0];
      var finalOptions = ensureDefaultHandlers(extra, {
        on20X: function on20X(response) {
          return response;
        },
        not20X: function not20X(response) {
          return _Promise.reject(response);
        }
      });
      var deleteArgs = legacy ? [undefined, finalOptions] : [doc, finalOptions];
      return dispatch(DELETE.apply(void 0, [definitiveUrl].concat(deleteArgs))).catch(catchApiError("Unable to delete resource ".concat(resource, "."))).then(function (response) {
        // notify this was a success
        // XXX: type SuccessPayload
        dispatch(success(_objectSpread({
          response: response
        }, payload)));
        return response;
      })
      // XXX: type ErrorPayload
      .catch(handleFailure(function (error) {
        return dispatch(failure(_objectSpread({
          error: error
        }, payload)));
      }));
    };
  };
  doDeleteOne.start = start;
  doDeleteOne.success = success;
  doDeleteOne.failure = failure;
  // Even though it can return a FetchError, in userland it will only type the successful promise.
  // A rejected promise will be typed as 'any' and such needs to be typed manually.
  // $FlowIgnore[incompatible-exact]
  return doDeleteOne;
};
export var createInvalidateAction = function createInvalidateAction(resource) {
  return createAction("[".concat(resource, "] invalidate whole resource"), payloadReducer, metaReducerFactory(INVALIDATE, resource));
};